import React from 'react';
import { Card } from 'semantic-ui-react';
import { Colors } from '../Colors';
import { DetailsBlockProps } from '../Domain/Interfaces/DetailsBlockProps';
import { TriggerTransaction } from '../Domain/Interfaces/TriggerTransaction';
import { FormatPrice } from '../Functions/FormatPrice';
import { ResultCard } from './ResultCard';

export const DetailsBlock: React.FC<DetailsBlockProps> = ({
  engineResults,
  canSeeDetails,
}) => {
  if (engineResults && canSeeDetails) {
    return (
      <div
        className="ui grid"
        style={{
          marginTop: '20px',
          paddingBottom: '80px',
          textAlign: 'center',
          justifyContent: 'left',
        }}
        data-testid={'details-container'}
      >
        <div style={{ justifyContent: 'left' }}>
          {engineResults.alertTransactions.map(
            (transaction: TriggerTransaction, i: number) => {
              return (
                <div key={i}>
                  <ResultCard
                    transaction={transaction}
                    userShares={transaction.numberOfShares}
                    isFirst={i === 0}
                  />
                </div>
              );
            },
          )}
          <Card
            fluid
            style={{
              backgroundColor: Colors.darkGreen,
              color: Colors.offWhite,
              borderRadius: 10,
              textAlign: 'left',
              padding: 10,
            }}
          >
            <Card.Description
              style={{
                color: Colors.offWhite,
                fontSize: 17,
                padding: 5,
              }}
            >
              Value with RiskAlert{' '}
              <span style={{ float: 'right' }}>
                {FormatPrice(+engineResults.valueWithAlerts.toFixed(0))}
              </span>
            </Card.Description>
            <Card.Description
              style={{
                color: Colors.offWhite,
                fontSize: 17,
                padding: 5,
              }}
            >
              Value Holding Stock
              <span style={{ float: 'right' }}>
                {FormatPrice(+engineResults.valueWithoutAlerts.toFixed(0))}
              </span>
            </Card.Description>
            <Card.Description
              style={{
                color: Colors.offWhite,
                fontSize: 17,
                padding: 5,
              }}
            >
              Total Gain/(Loss) using RiskAlert{' '}
              <span style={{ float: 'right' }}>
                {FormatPrice(+engineResults.gainOrLoss.toFixed(0))}
              </span>
            </Card.Description>
          </Card>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};
